export default "__VITE_ASSET__a9fc4a8d__"